export default __webpack_public_path__ + "static/media/Brace of Kuthchemes.acb83ccf.jpg";